import { LastUsedAuthenticationMethod } from '@shared/enum/last-used-authentication-method';
import { AccountCreationMethod } from '@shared/enum/account-creation-method';
import { DataHistory, DataModel } from '@shared/models/data-model';
import { PlatformUserGroup } from '@/app/platform/platform-core/user/models/platform-user-group';
import { UserData } from '@/app/platform/platform-shared/models/types';
import { OccupationType } from '@/app/platform/platform-shared/enum/occupation-type';

export class PlatformUser extends DataModel implements Readonly<UserData> {
  constructor(
    id: string,
    metadata: Partial<DataHistory>,
    public readonly firstName: string,
    public readonly lastName: string,
    public readonly email: string,
    public readonly hasAcceptedTerms: boolean,
    public readonly isVerified: boolean,
    public readonly accountCreationMethod: AccountCreationMethod,
    public readonly badgeId: string,
    public readonly displayName: string,
    public readonly lastAcceptedTermsOn: string,
    public readonly lastUsedAuthenticationMethod: LastUsedAuthenticationMethod,
    public readonly primeTimeId: string,
    public readonly userName: string,
    public readonly verifiedOn: string,
    public readonly groups: PlatformUserGroup[],
    public readonly occupationType: OccupationType
  ) {
    super(id);
  }

  is(model?: UserData): boolean {
    return super.is(model);
  }

  get isBediende(): boolean {
    return this.occupationType === OccupationType.Bediende;
  }

  static createDefault(initialValues?: Partial<PlatformUser>): PlatformUser {
    return new PlatformUser(
      initialValues?.id ?? '',
      {},
      initialValues?.firstName ?? '',
      initialValues?.lastName ?? '',
      initialValues?.email ?? '',
      initialValues?.hasAcceptedTerms ?? false,
      initialValues?.isVerified ?? false,
      initialValues?.accountCreationMethod ?? AccountCreationMethod.Unknown,
      initialValues?.badgeId ?? '',
      initialValues?.displayName ?? '',
      initialValues?.lastAcceptedTermsOn ?? '',
      LastUsedAuthenticationMethod.Unknown,
      initialValues?.primeTimeId ?? '',
      initialValues?.userName ?? '',
      initialValues?.lastAcceptedTermsOn ?? '',
      [],
      initialValues?.occupationType ?? OccupationType.Onbekend
    );
  }
}
